export default __webpack_public_path__ + "static/media/3.f1ad86c0.svg";